import React, { useEffect, useState, useRef } from "react";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LaunchIcon from '@material-ui/icons/Launch';

import Title from '@base/Title';
import Toast from '@base/Toast';
import Breadcrumbs from "@base/Breadcrumbs";
import ButtonPrimary from '@base/Button';
import ButtonHelp from "@base/Button/ButtonHelp";

export const Scanner = () => {
	const toastRef = useRef();

	const [ estacaoDigitalizacao, setEstacaoDigitalizacao ] = useState(false);

	const pageName = 'Digitalização';
	const breadcrumbs = [];

	useEffect(() => {
		fetch(process.env.REACT_APP_DIGITALIZACAO_URL, { mode: 'no-cors' })
			.then(() => {
				setEstacaoDigitalizacao(true);
				console.log("THEN");
			})
			.catch(() => setEstacaoDigitalizacao(false))			
	}, []);

	return (
		<>
			<Toast ref={toastRef} />
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Breadcrumbs links={breadcrumbs} active={pageName} />
				</Grid>
			</Grid>
			<Title>{pageName} <ButtonHelp tipo="DIGITALIZACAO" /></Title>

			{ estacaoDigitalizacao ?
				<Grid container spacing={3} >
					<Grid item xs={12} >
						<ButtonPrimary
							onClick={() => window.open(process.env.REACT_APP_DIGITALIZACAO_URL, "_blank")}
							name="Ir para o Sistema de Digitalização"
							startIcon={<LaunchIcon />}
						/>
					</Grid>
				</Grid>
			:
				<Typography variant="body2">
					Você está em um computador que não possui o sistema de Digitalização.
					Por favor, dirija-se a um outro computador que possua o sistema de Digitalização instalado.
				</Typography>
			}
		</>
	);
}

export default Scanner;
